var _classCallCheck = require("/home/miushery/Desktop/ehungry-test/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/miushery/Desktop/ehungry-test/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/miushery/Desktop/ehungry-test/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/miushery/Desktop/ehungry-test/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/miushery/Desktop/ehungry-test/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var React = require('react');

var NotificationItem = require('./NotificationItem');

var Constants = require('./constants');

var NotificationContainer = /*#__PURE__*/function (_React$Component) {
  "use strict";

  _inherits(NotificationContainer, _React$Component);

  var _super = _createSuper(NotificationContainer);

  function NotificationContainer(props) {
    var _this;

    _classCallCheck(this, NotificationContainer);

    _this = _super.call(this, props); // Fix position if width is overrided

    _this._style = props.getStyles.container(props.position);

    if (props.getStyles.overrideWidth && (props.position === Constants.positions.tc || props.position === Constants.positions.bc)) {
      _this._style.marginLeft = -(props.getStyles.overrideWidth / 2);
    }

    return _this;
  }

  _createClass(NotificationContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var notifications;

      if ([Constants.positions.bl, Constants.positions.br, Constants.positions.bc].indexOf(this.props.position) > -1) {
        this.props.notifications.reverse();
      }

      notifications = this.props.notifications.map(function (notification) {
        return React.createElement(NotificationItem, {
          ref: 'notification-' + notification.uid,
          key: notification.uid,
          notification: notification,
          getStyles: _this2.props.getStyles,
          onRemove: _this2.props.onRemove,
          noAnimation: _this2.props.noAnimation,
          allowHTML: _this2.props.allowHTML,
          children: _this2.props.children
        });
      });
      return React.createElement("div", {
        className: 'notifications-' + this.props.position,
        style: this._style
      }, notifications);
    }
  }]);

  return NotificationContainer;
}(React.Component);

module.exports = NotificationContainer;